/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PayorSignedContract/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import RemoveSignatureAction from './RemoveSignatureAction/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2CheckCircle from 'DesignSystem/Svgs/Tysiav2CheckCircle/index'
import ViewContractsAction from './ViewContractsAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PayorSignedContract({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/SignedContracts/Content/PayorSignedContract"
  
}) {
let payorSignedContractItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'payor_signed_contract_item',
path: 'isFirst',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let payorSignedContractPersonValueData = fromData.useDataFormat({ viewPath,
context: 'payor_signed_contract',
path: 'person',
format: fromHelpers.getText,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="PayorSignedContract.Horizontal"
  data-view-path={viewPath}
 style={{'--bblr-1-2kcfk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-2-2kcfk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-3-2kcfk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-2kcfk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-2kcfk': dtColorsWhite,'--bc-6-2kcfk': dtColorsNeutral200,'--pt-7-2kcfk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-8-2kcfk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-9-2kcfk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-10-2kcfk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-11-2kcfk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-12-2kcfk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-13-2kcfk': payorSignedContractItemIsFirstValueData ? "0px" : typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2CheckCircle
  viewPath={`${viewPath}/Tysiav2CheckCircle`}
 marginTop={dtSpaceXxs}
/>
<div
  data-testid="PayorSignedContract.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="normal"
 text="Contract is signed"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 data="payor_signed_contract.person"
 format="helpers.js getText"
 text={payorSignedContractPersonValueData}
/>
</div>
<div
  data-testid="PayorSignedContract.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<RemoveSignatureAction
  viewPath={`${viewPath}/RemoveSignatureAction`}
/>
<ViewContractsAction
  viewPath={`${viewPath}/ViewContractsAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}